var map = {
	"./ar.json": 26726,
	"./bg.json": 24901,
	"./ca.json": 23886,
	"./cs.json": 99789,
	"./da.json": 85638,
	"./de.json": 39929,
	"./el.json": 7498,
	"./en.json": 20790,
	"./eo.json": 37798,
	"./es.json": 18563,
	"./fa.json": 49603,
	"./fi.json": 2276,
	"./fr.json": 844,
	"./gl.json": 71077,
	"./he.json": 8818,
	"./hu.json": 64626,
	"./id.json": 98446,
	"./it.json": 20504,
	"./ja.json": 8566,
	"./ko.json": 37697,
	"./nb.json": 54870,
	"./nl.json": 13055,
	"./pl.json": 75143,
	"./pt-BR.json": 96837,
	"./ru.json": 69672,
	"./sl.json": 75329,
	"./sv.json": 93244,
	"./ta.json": 22446,
	"./th.json": 42009,
	"./ti.json": 27495,
	"./tr.json": 12021,
	"./vi.json": 90245,
	"./zh-Hans.json": 69207,
	"./zh-Hant.json": 35710
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72528;